// import React from 'react';
// import './Login.css'; // Be sure to create this file

// function Login() {
//   return (
//     <div className="login-bg">
//       <div className="login-container">
//         <div className="login-left">
//           {/* (Optional) Use an inline SVG to mimic the logo in the example */}

//         </div>
//         <div className="login-right">
//           <h2>Welcome !</h2>
//           <form autoComplete="off">
//             <div className="input-group">
//               <span className="input-icon">
//                 <i className="fa fa-user"></i>
//               </span>
//               <input type="text" placeholder="@username" required />
//             </div>
//             <div className="input-group">
//               <span className="input-icon">
//                 <i className="fa fa-lock"></i>
//               </span>
//               <input type="password" placeholder="Password" required />
//             </div>
//             <div className="login-options">
//               <a href="/" className="forgot-password">Forgot Password ?</a>
//             </div>
//             <button type="submit" className="login-btn">LOGIN</button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Login;

import React, { useState, useRef, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { NavLink, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Login.css";
const Login = () => {
  const [formData, setFormData] = useState({
    userName: "",
    password: "",
  });

  const [errors, setErrors] = useState({
    userName: "",
    password: "",
  });

  const [otpError, setOtpError] = useState("");

  const [reotpError, setReOtpError] = useState("");

  const userNameInputRef = useRef();
  const passwordInputRef = useRef();

  const [otpChallenge, setOtpChallenge] = useState(false);
  const [otp, setOtp] = useState("");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prev) => !prev);
  };

  const [isOtpVisible, setIsOtpVisible] = useState(false);
  const toggleOtpVisibility = () => {
    setIsOtpVisible((prev) => !prev);
  };

  const { sendRequest: putOTP } = useHttp();

  const [logErr, setLogErr] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [resendOtpCountdown, setResendOtpCountdown] = useState(0);
  const nav = useNavigate();

  useEffect(() => {
    if (resendOtpCountdown > 0) {
      const timer = setInterval(() => {
        setResendOtpCountdown((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [resendOtpCountdown]);

  const submitHandler = (event) => {
    setReOtpError("");
    event.preventDefault();
    if (validateForm()) {
      setLogErr("");

      const enteredUserName = userNameInputRef.current.value.trim();
      const enteredPassword = passwordInputRef.current.value.trim();

      // optional: Add validation

      setIsLoading(true);
      let url = `${process.env.REACT_APP_BASE_URL}/api/multipLoginApi/`;
      //console.log(url)
      fetch(url, {
        method: "POST",
        body: JSON.stringify({
          userName: enteredUserName,
          password: enteredPassword,
          returnSecureToken: true,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          setIsLoading(false);
          console.log(res);

          if (res.ok) {
            res.json().then((data) => {
              setOtpChallenge(data.id);
              setResendOtpCountdown(60);
            });
          } else {
            res.text().then((x) => {
              setLogErr(x);

              setIsLoading(false);
            });
          }
        })
        .catch((e) => {
          setLogErr("something went wrong");
          setIsLoading(false);
        });
    }
  };

  const { sendRequest: getServiceAllData } = useHttp();

  const serviceAllData = (userId) => {
    getServiceAllData(
      {
        url: `/api/serviceRoleAllocationByEmployee/?userId=${userId}`,
      },
      (data) => {
        localStorage.setItem("RoleAllocation", JSON.stringify(data));
      }
    );
  };

  const submitChallenge = (event) => {
    const inputOTP = otp;
    setReOtpError("");

    if (!inputOTP) {
      setOtpError("Please enter a valid OTP");

      return;
    } else {
      setOtpError("");
    }

    putOTP(
      {
        url: "/api/multipLoginApi/",
        method: "PUT",
        body: { id: otpChallenge, otp: inputOTP, useCase: "Warehouse" },
      },
      (res) => {
        const data = res.loginUserResponse || [];
        localStorage.setItem(
          "authData",
          JSON.stringify({
            loginUser: res.loginUserResponse,
            userList: res.userlist,
          })
        );
        console.log("Login Data", data);
        Cookies.set("token", data.Token);
        localStorage.setItem("token", data.Token);
        localStorage.setItem("attachmentFolder", data.attachmentFolder);
        localStorage.setItem("orgId", data.orgid);
        localStorage.setItem("id", data.userId);
        localStorage.setItem("userEmail", data.userEmail);
        localStorage.setItem("userContact", data.workContactNo);
        localStorage.setItem("orgCode", data.orgCode);

        localStorage.setItem("warehouseId", data.warehouseId);

        localStorage.setItem("organizationName", data.organizationName);
        localStorage.setItem("organizationAddress", data.organizationAddress);

        localStorage.setItem("organizationIcon", data.organizationIcon);

        localStorage.setItem("employeeName", data.employeeName);
        localStorage.setItem("useCase", data.useCase);
        localStorage.setItem("userIcon", data.userIcon);

        localStorage.setItem("userName", data.userName);
           localStorage.setItem("appName", data.appName);

        //Technical Setting
        localStorage.setItem("pageSize", 25);
        localStorage.setItem("decimalPattern", "^\\d*(\\.\\d{1,2})?$");
        localStorage.setItem("integerPattern", "^\\d*");
        localStorage.setItem("currencyCode", data.currency);
        localStorage.setItem("dateFormat", "dd/MM/yyyy");
        localStorage.setItem("empId", data.empId);
        localStorage.setItem("isMainUser", data.isMainUser);
        serviceAllData(data.userId);
        localStorage.setItem("isMultiAppAccess", res.isMultiAppAccess || false);
        nav("/");
      },

      (error) => {
        setOtpError(error);
      }
    );
  };

  //validation

  const validateForm = () => {
    let valid = true;
    setLogErr("");

    // console.log(formData);

    // Validate email
    if (!formData.userName) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        userName: "Please enter an user name",
      }));
      valid = false;
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, userName: "" }));
    }

    // Validate password
    if (!formData.password) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: "Please provide a password",
      }));
      valid = false;
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, password: "" }));
    }

    return valid;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevData) =>
      type === "checkbox"
        ? { ...prevData, [name]: checked }
        : { ...prevData, [name]: value }
    );
  };

  useEffect(() => {
    const handleWindowClose = () => {
      Cookies.remove("token");
      localStorage.clear();
    };

    window.addEventListener("beforeunload", handleWindowClose);

    return () => {
      window.removeEventListener("beforeunload", handleWindowClose);
    };
  }, []);

  const handleResendOTP = (event) => {
    setOtpError("");
    event.preventDefault();

    const userId = otpChallenge;

    let url = `${process.env.REACT_APP_BASE_URL}/api/resendOtp/`;

    fetch(url, {
      method: "POST",
      body: JSON.stringify({
        id: userId,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (res.ok) {
          res.json().then((data) => {
            console.log(data.message);
            toast.success(data.message || "Sent OTP to your email Id");
            setResendOtpCountdown(60);
          });
        } else {
          res.json().then((x) => {
            setReOtpError("Internal Server Error");
          });
        }
      })
      .catch((e) => {
 
        setReOtpError("something went wrong");
       
      });
  };

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        bodyClassName="toastBody"
      />
      <div className="login-bg">
        <div className="login-container">
       <div className="login-left">
  <div className="main-logo-container">
    <img
      src={require("../../../assests/images/goldanIcon.png")}
      alt="Main Logo"
      className="main-logo"
    />
  </div>

  <div className="powered-by">
    <p className="power">Powered By</p>
    <img
      src={require("../../../assests/images/logo1.png")}
      alt="Powered By Logo"
      className="powered-logo"
    />
  </div>
</div>

          <div className="login-right">
            {!otpChallenge ? (
              <>
                <h2>Welcome !</h2>
                <form
                  autoComplete="off"
                  onSubmit={submitHandler}
                  id="quickForm"
                >
                  <div className="input-group mb-2">
                    <span className="input-icon">
                      <i className="fa fa-user"></i>
                    </span>
                    <input
                      type="text"
                      id="userName"
                      name="userName"
                      ref={userNameInputRef}
                      tabIndex={1}
                      placeholder="User Name"
                      value={formData.userName}
                      onChange={handleChange}
                      className={errors.userName ? "invalid-input" : ""}
                      //  required
                    />
                  </div>
                  {errors.userName && (
                    <span className="error-msg">{errors.userName}</span>
                  )}
                  <div className="input-group mb-2">
                    <span className="input-icon">
                      <i className="fa fa-lock"></i>
                    </span>
                    <input
                      type={isPasswordVisible ? "text" : "password"}
                      id="password"
                      name="password"
                      tabIndex={2}
                      ref={passwordInputRef}
                      placeholder="Password"
                      value={formData.password}
                      onChange={handleChange}
                      className={errors.password ? "invalid-input" : ""}
                      autoComplete="off"
                      // required
                    />
                    <span
                      className={`password-toggle-icon fa ${
                        isPasswordVisible ? "fa-eye-slash" : "fa-eye"
                      }`}
                      onClick={togglePasswordVisibility}
                    />
                  </div>
                  {errors.password && (
                    <span className="error-msg">{errors.password}</span>
                  )}
                  <div className="login-options mb-2">
                    <NavLink
                      to="/360ForgotPassword"
                      className="forgot-password"
                    >
                      Forgot Password ?
                    </NavLink>
                  </div>

                  {logErr && <div className="log-error">{logErr}</div>}

                  <button
                    type="submit"
                    className="login-btn"
                    disabled={isLoading}
                  >
                    {isLoading ? "Loading..." : "LOGIN"}
                  </button>
                </form>
              </>
            ) : (
              <>
                <h2>Enter OTP</h2>
                <form onSubmit={(e) => e.preventDefault()}>
                  <div className="input-group mb-2">
                    <input
                      type={isOtpVisible ? "text" : "password"}
                      id="otp"
                      placeholder="OTP"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      className={otpError ? "invalid-input" : ""}
                      autoComplete="off"
                      //  required
                    />
                    <span
                      className={`password-toggle-icon fa ${
                        isOtpVisible ? "fa-eye-slash" : "fa-eye"
                      }`}
                      onClick={toggleOtpVisibility}
                    />
                  </div>
                  {otpError && <span className="error-msg">{otpError}</span>}
                  {reotpError && (
                    <span className="error-msg">{reotpError}</span>
                  )}

                  <div className="login-options resend-otp">
                    <button
                      onClick={handleResendOTP}
                      disabled={resendOtpCountdown > 0}
                      className="resend-btn"
                      type="button"
                    >
                      Resend OTP{" "}
                      {resendOtpCountdown > 0 && `(${resendOtpCountdown}s)`}
                    </button>
                  </div>

                  <div className="otp-actions">
                    <button
                      type="button"
                      className="login-btn"
                      onClick={submitChallenge}
                    >
                      Submit
                    </button>
                    <button
                      type="button"
                      className="cancel-btn"
                      onClick={() => setOtpChallenge(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
